import { throttle } from "lodash";
import React, { useCallback, useEffect } from "react";
import { compose } from "redux";

import withNewNotifications from "../../../../../../hocs/withNewNotifications";
import withTranslations from "../../../../../../hocs/withTranslations";
import Loader from "../../../../common/Loader";
import NoNotificationsDesktop from "./noNotifications/NoNotificationsDesktop";
import NotificationFactory from "./NotificationFactory";
import TabsButtons from "./Tabs";
import NoPermissionForPlan from "../../../../common/NoPermissionForPlan";
import withUserData from "../../../../../../hocs/withUserData";
import sortNotificationsTabs from "../../../../../../redux/modules/newNotifications/utils/sortNotificationsTabs";

const NotificationsTabs = ({
  translate,
  notificationsTabs,
  fetchNotifications,
  fetchMoreNotifications,
  markAsReadAction,
  initialFetchComplete,
  hasPermission,
  onToggle,
  selectedTab,
  onSelectedTabChange
}) => {
  useEffect(() => {
    if (!initialFetchComplete) {
      fetchNotifications();
    }
  }, []);

  const onFetchMoreNotifications = useCallback(
    throttle(() => {
      fetchMoreNotifications({ name: selectedTab.name });
    }, 1000),
    [fetchMoreNotifications, selectedTab?.name]
  );

  const onScroll = useCallback(
    event => {
      if (!selectedTab.endReached) {
        const { scrollTop, scrollHeight, clientHeight } = event.currentTarget;
        const offset = 100;

        if (scrollTop + clientHeight >= scrollHeight - offset) {
          onFetchMoreNotifications();
        }
      }
    },
    [onFetchMoreNotifications, selectedTab?.endReached]
  );

  if (!selectedTab) {
    return null;
  }

  return (
    <>
      <TabsButtons
        tabs={sortNotificationsTabs({ notificationsTabs, hasPermission }).map(
          ({ name, unreadCount, styleType }) => {
            return {
              key: name,
              count: unreadCount,
              text: translate(name),
              selected: selectedTab.name === name,
              styleType,
              onClick: () => {
                const nextTab = notificationsTabs.find(tab => tab.name === name);
                if (nextTab) {
                  onSelectedTabChange?.(nextTab);
                }
              }
            };
          }
        )}
      />
      {!hasPermission(selectedTab.permissions) ? (
        <NoPermissionForPlan
          className={"items"}
          permissions={selectedTab.permissions}
          descriptionTranslationKey="noPermissionNotifications_description"
          onLinkClick={onToggle}
        />
      ) : selectedTab.notifications.length <= 0 ? (
        selectedTab.loading ? (
          <div className={"items flex justify-center align-center"}>
            <Loader small />
          </div>
        ) : (
          <NoNotificationsDesktop className={"items"} />
        )
      ) : (
        <ul
          className={"items mb-0 pl-0 list-none overflow-y-auto pt-1"}
          onScroll={onScroll}
        >
          {selectedTab.notifications.map((item, index) => {
            const isLast =
              index >= selectedTab.notifications.length - 1;

            return (
              <li key={`notification-item-${item.id}`} className={"ml-0"}>
                <NotificationFactory
                  markAsReadAction={markAsReadAction}
                  onToggle={onToggle}
                  notification_type={item.notification_type}
                  message={item.message}
                  sub_message={item.sub_message}
                  config={item.config}
                  date={item.date}
                  read={item.read}
                  item={item}
                  isDesktop
                />
                {isLast ? (
                  selectedTab.loading ? (
                    <div>
                      <Loader small />
                    </div>
                  ) : null
                ) : (
                  <div className={"border-bottom border-bottom-gray-1 mx-4"} />
                )}
              </li>
            );
          })}
        </ul>
      )}
    </>
  );
};

export default compose(
  withTranslations,
  withNewNotifications,
  withUserData
)(NotificationsTabs);
